// Logo Component
function Logo({ className = "w-16 h-16" }) {
  return (
    <svg 
      version="1.2" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50" 
      className={className}
    >
      <path 
        d="M25 0.055c-4.227 0 -8.21 1.057 -11.696 2.91l21.79 7.019c8.573 2.752 13.446 11.909 10.741 20.497 -2.263 7.169 -9.03 11.672 -16.191 11.404 -2.295 -0.087 -3.864 -2.374 -3.155 -4.566 0.481 -1.498 1.901 -2.476 3.47 -2.421 4.101 0.134 7.973 -2.476 9.227 -6.609 1.498 -4.897 -1.325 -10.071 -6.199 -11.64L6.68 8.084C2.571 12.524 0.055 18.47 0.055 25c0 7.831 3.612 14.819 9.259 19.393L16.325 22.587c0.591 -1.838 2.563 -2.847 4.401 -2.256s2.847 2.563 2.256 4.401l-7.5 23.328c2.934 1.207 6.144 1.885 9.519 1.885 13.778 0 24.945 -11.167 24.945 -24.945S38.778 0.055 25 0.055" 
        fill="#e3ff04"
      />
    </svg>
  )
}

export function GameLoader() {
  return (
    <div className="min-h-screen bg-background-dark flex items-center justify-center">
      <div className="text-center space-y-6">
        {/* Animated Logo with pulse and fade */}
        <div className="relative">
          <div className="animate-pulse">
            <Logo className="w-20 h-20 mx-auto animate-[fadeInOut_2s_ease-in-out_infinite]" />
          </div>
          {/* Glow effect behind logo */}
          <div className="absolute inset-0 w-20 h-20 mx-auto bg-game-primary/30 blur-xl rounded-full animate-pulse" />
        </div>
        
        {/* Brand name with fade animation */}
        <div className="animate-[fadeInOut_2s_ease-in-out_infinite]">
          <h1 className="text-2xl font-black text-white tracking-tight">POLYTORIA</h1>
        </div>
        
        {/* Loading text */}
        <p className="text-sm text-slate-500 animate-pulse">Loading game...</p>
      </div>
      
      {/* CSS for fade in/out animation */}
      <style>{`
        @keyframes fadeInOut {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  )
}
